import ChartLegend from '@app/components/charts/legends/chart-legend';
import ReportContent from '@app/components/reports/components/report-content';
import Text from '@shared/components/content/text';
import SimpleSelect from '@shared/components/simple-select';

export type ReportChartConfig = Record<
  string,
  {
    label: string;
    color: string;
    unit?: string;
  }
>;

interface ReportChartPageProps {
  title: string;
  description: string | React.ReactNode;
  variantOptions: string[];
  variant?: string;
  setVariant: (value: string) => void;
  variantsEnabled: boolean;
  chartConfig: ReportChartConfig;
  children: React.ReactNode;
}

export default function ReportChartPage({
  title,
  description,
  variantOptions,
  variant,
  setVariant,
  variantsEnabled,
  chartConfig,
  children,
}: ReportChartPageProps) {
  const series = Object.values(chartConfig);
  return (
    <ReportContent variant="appendix">
      <div className="flex flex-col space-y-4">
        <div className="grid h-10 w-full grid-cols-12 items-center gap-4">
          <Text variant="h3" className="col-span-9">
            {title}
          </Text>
          {variantsEnabled && (
            <SimpleSelect
              className="col-span-3"
              value={variant}
              onValueChange={setVariant}
              options={variantOptions}
              placeholder="Select comparison..."
            />
          )}
        </div>
        <div className="grid grid-cols-12">
          <div className="col-span-9">
            {typeof description === 'string' ? (
              <Text variant="reportBody" className="max-w-3xl">
                {description}
              </Text>
            ) : (
              <div className="max-w-3xl">{description}</div>
            )}
          </div>
          {series.length > 1 && (
            <div className="col-span-3 flex items-center justify-end space-x-4 pr-10">
              {series.map((config, index) => (
                <ChartLegend
                  key={index}
                  name={config.label}
                  color={config.color}
                />
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="pr-8">{children}</div>
    </ReportContent>
  );
}
